import cn from "classnames";
import styles from "./TableAndSearchMaster.module.scss";
import Table from "./Table";
import Search from "../common/Search";
import Button from "@material-ui/core/Button";
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useCallback,
} from "react";
import { Link, useHistory } from "react-router-dom";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import {
  getSitePerformanceRequest,
  getSiteStatusRequest,
} from "../../services/axiosBaseClient";
import { getRequest, postRequest } from "services/axiosBaseClient";
import LocalStorageService from "services/tokenlocalstorage.service";
import NewSearch from "./NewSearch";

function TableAndSearchMaster1(props) {
  return (
    <div className={cn(styles.block7, styles.block7_layout)}>
      <div className={cn(styles.flex5, styles.flex5_layout)}>
        <div className={cn(styles.flex4_spacer)} />
        <div>
          <Search
            onSearch={props.searchOpts.onSearch}
            placeholder={props.searchOpts.placeholder}
          />
        </div>

        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            columns={props.columns}
            data={props.data}
            paginationDoubleScreen={props.paginationDoubleScreen}
          />
        </div>

        <div className={cn(styles.flex4_spacer)} />
      </div>
    </div>
  );
}

var noData = [];
var tempTab;
var tempSearchTrigger = "inactive";
var tempBtnType;

export default function TableAndSearchMaster(props) {
  const history = useHistory();

  const scrollRef = useRef(null);

  const scrollFun = () => {
    !props.scroll && scrollRef?.current?.scrollTo(0, 0);
  };

  const filterInitialValue = {
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    zoneId: "",
    charger: "",
    time: "HOUR_24",
  };

  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectTime, setSelectTime] = useState(24);
  const [filter, setFilter] = useState(filterInitialValue);
  const [performanceData, setSitePerformanceData] = useState([]);
  const [performanceDataLabel, setSitePerformanceLabel] = useState([]);
  const [performanceDataLabelVal, setSitePerformanceLabelVal] = useState([]);
  const [filterAction, setFilterAction] = useState([0, 1]);
  const [userfilterAction, setUserFilterAction] = useState(0);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [deletedAssets, setDeletedAssets] = useState([]);
  const getSites = useCallback(async () => {
    await getRequestInAssets("bss/site/siteList")
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getSites();
  }, []);

  // useEffect(()=>{
  //   console.log("am runingggg")
  //   tempBtnType = localStorage.getItem("headerBtnType");
  //   tempSearchTrigger = localStorage.getItem("tableSearchTigger");
  //    if(tempBtnType =="reset" || tempSearchTrigger =="active" ) {
  //      setFilterAction(1)
  //    } else if(tempBtnType === "submit" || tempSearchTrigger =="active") {
  //      setFilterAction(1)
  //    } else {
  //      setFilterAction(0)
  //    }
  //    // if (props?.headerFilterParms && Object?.keys(props?.headerFilterParms).length > 0) {
  //    //   console.log(props?.headerFilterParms,"props?.headerFilterParms")
  //    //   setFilterAction(1);
  //    //   // filterAction=1
  //    //   console.log(filterAction,"AMM RUNINGGGG")
  //    // } else {
  //    //   setFilterAction(1);
  //    //   // filterAction =0
  //    //   console.log(filterAction,"AMM RUNINGGGG")
  //    // }
  //    console.log(userfilterAction,"userfilterAction")
  //  },[props.headerFilterParms, props.searchOpts.onSearch]);

  useEffect(() => {
    tempBtnType = localStorage.getItem("headerBtnType");
    tempSearchTrigger = localStorage.getItem("tableSearchTigger");
    if (tempBtnType == "reset" || tempSearchTrigger == "active") {
      setUserFilterAction(1);
    } else if (tempBtnType === "submit" || tempSearchTrigger == "active") {
      setUserFilterAction(1);
    } else {
      setUserFilterAction(0);
    }
    // const valueCheck = localStorage.getItem("lastTableSearch")
    // tempBtnType = localStorage.getItem("headerBtnType");
    // console.log(tempBtnType,"tempBtnType")
    // console.log(valueCheck.length,"valueCheck")
    // tempSearchTrigger = localStorage.getItem("tempSearchTrigger");
    // console.log(tempSearchTrigger,"tempSearchTrigger")
    //  if(tempBtnType =="reset" || tempSearchTrigger =="active" ) {
    //    setUserFilterAction(1)
    //    console.log("am run1")
    //  } else if(tempBtnType === "submit" || tempSearchTrigger =="active" ) {
    //    setUserFilterAction(1)
    //    console.log("am run2")
    //  } else if (tempBtnType === "off" && valueCheck == 0) {
    //   setUserFilterAction(0)
    //  }
    //   else {
    //   console.log("am run3")
    //    setUserFilterAction(0)
    //  }
  }, [props.headerFilterParms, props.searchOpts.onSearch]);

  // const onSearchResult = (filter, data) => {
  //   console.log(filter, data,"DATAA")
  //   props.searchOpts.onSearch(filter);
  // };

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      "bss/swappingStation/getswapStationInfo?siteId=" + siteId
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data?.swapStationList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleClick = (btnType) => {
    if (open) {
      // startDate: 1654490170,
      // endDate: 1655097566,
      // siteId: 1,
      // chargerId: 0,
      // state: "",
      // city: "",
      // zoneId: 0,
      // setOpen(false);
      if (btnType == "reset") {
        filter.time = filterInitialValue.time;
        filter.chargerId = "";
        filter.siteId = "";
        setFilter(filterInitialValue);
        setFilterAction([1, filterAction[1] == 0 ? 1 : 0]);
        props.onReset();
        getSitePerformanceData("False", filter);
        setChargerList([]);
      } else if (btnType == "apply") {
        setFilterAction([1, filterAction[1] == 0 ? 1 : 0]);
        //topSites=False&timeFilterEnum=HOUR_12
        //cityId=1&name=nxjskabh&siteId=7&stateId=1&swapStationId=1&timeFilterEnum=MONTH_3&zoneId=1"
        //cityId=1&name=nxjskabh&siteId=7&stateId=1&swapStationId=1&timeFilterEnum=MONTH_3&zoneId=1"
        const headerFilterObj = JSON.parse(
          LocalStorageService.get("headerFilter")
        );

        props.searchOpts.onFilterSearch(
          //if (searchString === undefined || searchString === "")
          // "startDate=" +
          //   filter.startDate +
          //   "&endDate=" +
          //   filter.endDate +

          (filter?.siteId === undefined || filter?.siteId === ""
            ? ""
            : "siteId=" + filter.siteId) +
            (filter?.chargerId === undefined || filter?.chargerId === ""
              ? ""
              : "&swapStationId=" + filter.chargerId) +
            (filter?.time === undefined || filter?.time === ""
              ? ""
              : "&timeFilterEnum=" + filter.time) +
            (headerFilterObj?.stateId === undefined ||
            headerFilterObj?.stateId === ""
              ? ""
              : "&stateId=" + headerFilterObj.stateId) +
            (headerFilterObj?.cityId === undefined ||
            headerFilterObj?.cityId === ""
              ? ""
              : "&cityId=" + headerFilterObj.cityId) +
            (headerFilterObj?.zoneId === undefined ||
            headerFilterObj?.zoneId === ""
              ? ""
              : "&zoneId=" + headerFilterObj.zoneId)
        );
      } else {
        getSitePerformanceData("False", filter);
        // setSelectTimeValue(selectTime);
        // getEnergyGraph(filter);
        // getSwappingGraph(filter);
        // getFaultGraph(filter);
        // getBatteryCount  AndStatus(filter);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const getSitePerformanceData = useCallback(async (e, filter) => {
    const payload = {
      city: "",
      endDate: filter.endDate,
      name: "",
      siteId: filter.siteId,
      startDate: filter.startDate,
      state: filter.state,
      zoneId: filter.zoneId,
    };
    // await getSitePerformanceRequest(
    //   "bss/getSiteperformance?topSites=" + e + "&timeFilterEnum=" + filter?.time
    // )
    await getRequest(
      "bss/getBatteryList?endDate=" +
        payload.endDate +
        "&siteId=" +
        payload.siteId +
        "&startDate=" +
        payload.startDate
    )
      .then((res) => {
        if (res && res?.data) {
          setSitePerformanceData(res?.data);
          var optionData = res;
          var arraLabel = [];
          var arraLabel = [];
          var arraLabelval = [];
          var arr1 = [];
          var colorArr = ["#9AAB04", "#1CAF9A", "#FF5C75"];
          optionData.data.map(
            (person, index) => (
              (arr1 = []),
              arraLabel.push(person.siteName),
              (arr1 = [person.start, person.max, person.end]),
              arraLabelval.push({
                data: arr1,
                emphasis: {
                  focus: "series",
                },
                type: "line",
                smooth: true,
                areaStyle: {
                  color: colorArr[index],
                },
              })
            )
          );
          setSitePerformanceLabel(arraLabel);
          setSitePerformanceLabelVal(arraLabelval);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getTime = (val) => {
    const endTime = Math.round(new Date().getTime() / 1000);
    const startTime = endTime - val * 3600;

    filter.endDate = endTime;
    filter.startDate = startTime;
  };

  // useEffect(() => {
  //   getTime(24);
  // }, []);

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setFilter({ ...filter, [name]: value });

  //   if (event.target.name == "time") {
  //     setSelectTime(event.target.value);
  //     // getTime(event.target.value);
  //   }
  //   if (event.target.name == "siteId") {
  //     getChargers(event.target.value);
  //   }
  // };

  function selectedCheckBoxData(selectedRows) {
    setCheckBoxData(selectedRows);
  }
  const handleDelete = (data) => {
    if (data.length > 0) {
      setDeletedAssets((prevDeletedAssets) => [...prevDeletedAssets, ...data]);
      props.selectedData(data);
    }
    setCheckBoxData([]); 
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2628000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7884000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name == "siteId") {
      setFilter({ ...filter, [name]: value, chargerId: "" });
      getChargers(event.target.value);
    }
  };

  const refOpen = useRef(open);
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);
 
  return (
    <div className={cn(styles.block25, styles.block25_layout)}>
      <div className={cn(styles.flex6, styles.flex6_layout)}>
        <div className={cn(styles.flex7, styles.flex7_layout)}>
          {props.isCheckBox && checkBoxData.length > 0 ? (
            <>
              <p className={cn(styles.flex10_heading)}>
                {checkBoxData.length} selected
              </p>
              <div className={cn(styles.flex7_spacer)} />

              <button
                className={cn(styles.flex10_button)}
                onClick={() => handleDelete(checkBoxData)}
              >
                Delete
              </button>
            </>
          ) : (
            <>
              <div className={cn(styles.flex7_item)}>
                <NewSearch
                  className={cn(styles.block8, styles.block8_layout)}
                  // className={cn(styles.flex7_item)}
                  // styles={{ width: "100%" }}
                  // onSearch={props.searchOpts.onSearch}
                  onSearch={props.searchOpts.onSearch}
                  placeholder={props.searchOpts.placeholder}
                  // setFilterAction={setFilterAction}
                  // setUserFilterAction={setUserFilterAction}
                  // filterAction={filterAction}
                  // setSearch={props.searchOpts.setSearch}
                  tempSearch={props.tempSearch}
                  // tempSearchTrigger={tempSearchTrigger}
                  // userfilterAction={userfilterAction}
                />
              </div>
              <div className={cn(styles.flex7_spacer)} />
            </>
          )}

          {props.searchOpts.filter ? (
            <div className={cn(styles.flex5_item1)}>
              <div
                ref={wrapperRef}
                style={{ cursor: "pointer" }}
                className={cn(styles.block26, styles.block26_layout)}
              >
                <div className={cn(styles.block27, styles.block27_layout)}>
                  <div className={cn(styles.block28_spacer)} />
                  <div className={cn(styles.block27_item)}>
                    <img
                      src={require("assets/filterwhite.png").default}
                      style={{ marginTop: "5px", marginRight: "5px" }}
                    />
                  </div>
                  <div className={cn(styles.block27_spacer)} />
                  <div
                    ref={wrapperRef}
                    style={{ cursor: "pointer" }}
                    className={cn(styles.text_body1, styles.text_body1_layout)}
                  >
                    {"Filters"}
                  </div>

                  <div>
                    {open && (
                      <div id="filter" open={open} ref={wrapperRefInside}>
                        <div
                          className={cn(
                            styles.status1_block,
                            styles.status1_block_layout
                          )}
                        >
                          <div>
                            <select
                              style={{ width: "80%", height: "35px" }}
                              name="time"
                              id="time"
                              onChange={handleChange}
                              value={filter.time}
                            >
                              <option value="" disabled selected>
                                Select Time Period
                              </option>
                              <option value="HOUR_24" selected>
                                Last 24 hours
                              </option>
                              {/* <option value="24">Last 24 hours</option> */}
                              <option value="HOUR_12">Last 12 hours</option>
                              <option value="WEEK">Last 1 week</option>
                              <option value="WEEK_2">Last 2 weeks</option>
                              <option value="MONTH">Last 1 month</option>
                              <option value="MONTH_3">Last 3 months</option>
                            </select>
                          </div>

                          <div>
                            <select
                              style={{ width: "80%", height: "35px" }}
                              name="siteId"
                              id="siteId"
                              onChange={handleChange}
                              value={filter.siteId}
                            >
                              <option value="" selected>
                                Select Site
                              </option>
                              {sitesList?.map((obj) => {
                                return (
                                  <option value={obj.id}>{obj.name}</option>
                                );
                              })}
                            </select>
                          </div>

                          <div>
                            <select
                              style={{ width: "80%", height: "35px" }}
                              name="chargerId"
                              id="chargerId"
                              onChange={handleChange}
                              value={filter.chargerId}
                            >
                              <option value="" disabled selected>
                                Select Swap Station
                              </option>
                              {chargerList &&
                                chargerList?.map((obj) => {
                                  return (
                                    <option value={obj.swapStationId}>
                                      {obj.swapStationName}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>

                          <div>
                            <Button
                              style={{
                                background: "#E3324C",
                                color: "white",
                                margin: "15px 0px 6px 35px",
                                width: "85px",
                                height: "28px",
                                lineHeight: "24px",
                              }}
                              onClick={() => {
                                handleClick("reset");
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              style={{
                                background: "#23297A",
                                color: "white",
                                margin: "15px 0px 6px 20px",
                                width: "85px",
                                height: "28px",
                                lineHeight: "24px",
                              }}
                              onClick={() => {
                                handleClick("apply");
                              }}
                            >
                              Apply
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          {props.searchOpts.addInvoice ? (
            <div className={cn(styles.flex5_item1)}>
              <div style={{ flex: "0 0 max-content" }}>
                <Link to="/Invoice/AddInvoice">
                  <div className={cn(styles.flex7_item1)}>
                    <div
                      className={cn(
                        styles.Invoiceblock26,
                        styles.Invoiceblock26_layout
                      )}
                    >
                      <div
                        className={cn(styles.block27, styles.block27_layout)}
                      >
                        <div className={cn(styles.block27_item)}>
                          <img
                            src={require("assets/Vector (5).png").default}
                            style={{ marginTop: "3px", marginRight: "5px" }}
                          />
                        </div>
                        <div className={cn(styles.block27_spacer)} />
                        <div
                          className={cn(
                            styles.text_body1,
                            styles.text_body1_layout
                          )}
                        >
                          {"Add Invoice"}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className={cn(styles.box16, styles.box16_layout)}>
        {/* <Table columns={props.columns} data={props.data} /> */}
        {props?.data?.length < 1 || props?.data == null ? (
          <div style={{ overflowX: "auto" }}>
            <Table
              columns={props.columns}
              data={noData}
              activepageCount={props.activepageCount}
              paginationCountHanlde={props.paginationCountHanlde}
              paginationDoubleScreen={props.paginationDoubleScreen}
            />
            {/* no_data_found_container */}
            <div className={cn(styles.no_data_found_container)}>
              <img
                src={require("assets/Search_No_data_Found.svg").default}
                height={"60px"}
                width={"60px"}
              ></img>
              <h5 className={cn(styles.no_data_found_label)}>
                No Record Found
              </h5>
              {window.scrollTo({ top: 0 })}
            </div>
          </div>
        ) : (
          <div ref={scrollRef} style={{ overflowX: "auto" }}>
            <Table
              totalCount={props.totalCount}
              columns={props.columns}
              data={props.data}
              scroll={scrollFun}
              scrollRef={scrollRef}
              activepageCount={props.activepageCount}
              paginationCountHanlde={props.paginationCountHanlde}
              paginationDoubleScreen={props.paginationDoubleScreen}
              tigger={props?.tigger}
              // table={props.table}
              tabTemp={props?.tabTemp}
              tempKey={tempTab}
              headerFilterParms={props.headerFilterParms}
              filterAction={filterAction}
              tempBtnType={tempBtnType}
              tempSearch={props.tempSearch}
              tempSearchTrigger={tempSearchTrigger}
              userfilterAction={userfilterAction}
              isCheckBox={props.isCheckBox}
              checkBoxData={selectedCheckBoxData}
              deletedAssets={deletedAssets}
            />
          </div>
        )}
      </div>
    </div>
  );
}
